<style lang="scss" scoped>
@screen mobile {
  .section {
    &__header {
      @apply px-4;
    }
    &__wrapper {
      @apply px-4;
      max-width: calc(100% - 2rem) ;
    }
  }
}
</style>

<template>
  <article class="section section--full-width">
    <header class="section__header">
      <h2 class="section__title">Serviços</h2>
    </header>

    <section class="section__wrapper section__wrapper--no-border">
      <p class="section__description">
        Cadastre aqui os preços dos serviços negociados com os planos de saúde
        e os preços de seus atendimentos particulares. Essas informações serão
        trazidas automaticamente para facilitar futuros agendamentos.
      </p>
      <div class="section__body prices">
        <transition-group name="fade">
          <dr-prices
            v-if="loaded"
            key="component_dr-prices"
          />

          <dr-health-insurance
            v-if="loaded"
            key="component_dr-health-insurance"
          />

          <dr-medical-services
            v-if="loaded"
            key="component_dr-medical-services"
          />
        </transition-group>
      </div>
    </section>
  </article>
</template>

<script>
import DrPrices from '@/components/layout/prices/prices'
import DrHealthInsurance from '@/components/layout/prices/healthInsurance'
import DrMedicalServices from '@/components/layout/prices/medicalServices'

export default {
  components: {
    DrPrices,
    DrHealthInsurance,
    DrMedicalServices
  },

  data () {
    return {
      loaded: true
    }
  }
}
</script>
